import { render } from "./LangModal.vue?vue&type=template&id=ad01558a"
import script from "./LangModal.vue?vue&type=script&lang=js"
export * from "./LangModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__